import { twMerge } from 'tailwind-merge';
import { ExternalLink } from '../../../../../components/Clickables/ExternalLink/ExternalLink';
import { ArrowUpRightIcon } from '../../../../../components/Icons/ArrowUpRightIcon';

interface IProps {
  latitude: number;
  longitude: number;
  className?: string;
}

const GOOGLE_MAPS_DIRECTION_URL = 'https://www.google.com/maps/dir/?api=1';

export const GoogleMapsLink = ({ latitude, longitude, className }: IProps) => {
  const googleMapsUrl = `${GOOGLE_MAPS_DIRECTION_URL}&destination=${latitude},${longitude}`;

  return (
    <ExternalLink
      className={twMerge(
        'heading-text-xxs constantSize flex items-center font-heading !font-medium text-trench',
        className,
      )}
      href={googleMapsUrl}
      target="_blank"
      variant="textNone"
    >
      Directions <ArrowUpRightIcon />
    </ExternalLink>
  );
};
